import * as mutationType from "../mutation_types";

const state = {
  list: []
};

const getters = {
  list: state => state.list
};

const actions = {
  getRecognitions({ commit }, filter) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/recognitions", { params: filter })
        .then(res => {
          commit(mutationType.SET_RECOGNITIONS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveRecognition({ commit }, recognition) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`/api/recognitions`, recognition)
        .then(res => {
          commit(mutationType.SET_RECOGNITION, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  likeRecognition({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/recognitions/${id}/like`)
        .then(res => {
          commit(mutationType.SET_RECOGNITION, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  unlikeRecognition({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/recognitions/${id}/unlike`)
        .then(res => {
          commit(mutationType.SET_RECOGNITION, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_RECOGNITIONS](state, list) {
    state.list = list;
  },
  [mutationType.SET_RECOGNITION](state, item) {
    let index = state.list.findIndex(cv => cv.id == item.id);
    if (index >= 0) {
      state.list[index] = Object.assign(state.list[index], item);
    } else {
      state.list.push(item);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
